
import * as types from './types';

// Mutations Object for LabelSettings. Use it by importing label/types.js and calling commit() from  label/actions.js Action File.
export const labelSettingsMutations = {
  [types.LabelSettingsData.SET.ALL] (state, payload) {
    state.labelSettingsData = payload;
  }
}